import { Stack, styled } from "@mui/material";

export const OrganizationManagementCard = styled("div")(({ theme }) => ({
	backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
	...theme.typography.body2,
	padding: theme.spacing(2),
	textAlign: "center",
	color: theme.palette.text.secondary,
	boxShadow: "0 1px 3px grey",
	borderRadius: "5px",
	position: "relative",
	width: "30%",
	margin: "10px auto",
	display: "flex"
}));

export const KillSwitchDialogContent = styled("div")(() => ({
	display: "flex",
	justifyContent: "space-evenly"
}));

export const OrganizationManagementItemStatusText = styled("div")(() => ({
	color: "#245055",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
}));

export const OrganizationManagementItemTitle = styled("p")(() => ({
	fontSize: "1rem",
	marginLeft: "10px",
	fontWeight: "600"
}));

// QA fix: center the settings in a constrained column (matches the role
// permissions page). The outer container handles scrolling, so this no longer
// needs its own overflow.
export const OrganizationManagementStack = styled(Stack)(({ theme }) => ({
	display: "flex",
	maxWidth: 760,
	width: "100%",
	margin: "0 auto",
	padding: "8px 24px 32px"
}));


export const OrganizationManagementContainer = styled("div", {
	shouldForwardProp: (prop) => prop !== "height",
})<{ height?: string }>(({ theme, height }) => ({
	overflowY: "auto",
	height: height,
	"&::-webkit-scrollbar": {
		backgroundColor: "#FFFFFF",
		width: "15px",
		borderRadius: "0px 0px 14px 0px"
	},
	"&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
		borderRadius: "8px",
		backgroundColor: "rgba(2, 213, 171, 0.55)",
		width: "7px",
		border: "4px solid transparent",
		backgroundClip: "content-box"
	}
}));